/**
 * CardOptions.js
 */

import { gsap, Power2 } from 'gsap';

export default class CardOptions {
  constructor(btn) {
    this.$btn = btn;
    this.$options = this.$btn.parentElement.querySelector('.card-options');
    this.toggleOptions = this.toggleOptions.bind(this);
    this.active = false;

    this.$btn.addEventListener('click', this.toggleOptions);
  }

  toggleOptions() {
    gsap.to(this.$options, {
      autoAlpha: this.active ? 0 : 1,
      translateX: this.active ? '80px': 0,
      ease: Power2.easeOut,
      duration: .4,
    });

    Array.from(this.$btn.children).forEach(icon => {
      icon.classList.toggle('hidden');
    });

    this.active = !this.active;
  }
};